"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _framerMotion = require("framer-motion");

var _propTypes = require("prop-types");

var initial = {
  opacity: 0
};
var end = {
  opacity: 1
};

var AnimatePresenceMotion = function AnimatePresenceMotion(_ref) {
  var open = _ref.open,
      children = _ref.children,
      initialAnimation = _ref.initialAnimation,
      endAnimation = _ref.endAnimation;
  return (0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
    children: open && (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
      initial: initialAnimation,
      animate: endAnimation,
      exit: initialAnimation,
      children: children
    })
  });
};

AnimatePresenceMotion.propTypes = {
  open: _propTypes.bool,
  children: _propTypes.node,
  initialAnimation: (0, _propTypes.shape)({}),
  endAnimation: (0, _propTypes.shape)({})
};
AnimatePresenceMotion.defaultProps = {
  open: false,
  children: undefined,
  initialAnimation: initial,
  endAnimation: end
};
var _default = AnimatePresenceMotion;
exports["default"] = _default;
//# sourceMappingURL=AnimatePresenceMotion.js.map